import LogsPanelContext from '@crm/contexts/LogsPanelContext'
import * as React from 'react'

import { NoteForm } from './NoteForm'

export const CreateNote = () => {
  const { toggleCreateNote } = React.useContext(LogsPanelContext)

  return <NoteForm onCloseForm={toggleCreateNote} />
}
